import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { IRouteGuardSettings } from '@nha/auth/route-guards/interface/iroute-guard-settings.interface';
import { of as observableOf } from 'rxjs';
import { UserSessionService } from '../services/user-session.service';
import { appSettings } from '@nha/config';

export const CanActivateGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
	const userSessionService = inject(UserSessionService);
	const router = inject(Router);

	const routeConfig: IRouteGuardSettings = route.data.routeGuardSettings || {
		featureFlag: undefined,
		entitlements: [],
		redirect: '/403'
	};

	/** default the access */
	let entitlementAccess: boolean = routeConfig.entitlements.length === 0;
	let featureFlagAccess: boolean = !routeConfig.featureFlag;

	/** check the entitlements */
	if (routeConfig.entitlements.length > 0) {
		if (typeof routeConfig.entitlements[0] === 'string') {
			if (userSessionService.hasAnyEntitlement(routeConfig.entitlements as string[])) {
				entitlementAccess = true;
			}
		} else {
			if (userSessionService.hasAnyEntitlement(routeConfig.entitlements as { entitlementType: string; entitlementName: string }[])) {
				entitlementAccess = true;
			}
		}
	}

	/** check the feature flag */
	if (routeConfig.featureFlag) {
		featureFlagAccess = appSettings.featureFlags.includes(routeConfig.featureFlag);
	}

	/** check access */
	if (!entitlementAccess || !featureFlagAccess) {
		router.navigate([routeConfig.redirect]);
	}

	/** return the access boolean */
	return observableOf(entitlementAccess && featureFlagAccess);
};

export const canActivateChild: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => CanActivateGuard(route, state);
